import {
  ExamLocationRequestList,
  ExamLocationRequestListFilterSection,
  ExamLocationRequestListNavigationTabs,
  ExamLocationRequestStatusSummary,
} from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useNavigate, useParams } from '@exam-center/router';
import { AddIcon, Button, PaperSection, Flex, Divider } from '@shared/components';
import { PermissionGuard, WithPermission } from '@shared/permissions';

export default function PermissionRequiredExamLocationManagementRequestsPage() {
  return (
    <PermissionGuard
      requiredPermission={[APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW]}
    >
      <ExamLocationManagementRequestsPage />
    </PermissionGuard>
  );
}

export function ExamLocationManagementRequestsPage() {
  const navigate = useNavigate();

  const { examCenterCode } = useParams('/:examCenterCode/exam-location/requests');

  return (
    <PaperSection
      title='รายการยื่นคำขออนุมัติสถานที่สอบ'
      endAdornment={
        <WithPermission
          requiredPermission={[
            APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.CREATE,
          ]}
        >
          <Button
            startIcon={<AddIcon />}
            onClick={() => {
              navigate('/:examCenterCode/exam-location/requests/create', {
                params: {
                  examCenterCode,
                },
              });
            }}
          >
            สร้างคำขออนุมัติ
          </Button>
        </WithPermission>
      }
    >
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4), p: theme.spacing(6) })}
      >
        <ExamLocationRequestStatusSummary />
        <ExamLocationRequestListFilterSection />
        <Flex
          sx={(theme) => ({
            borderRadius: theme.shape.rounded(2),
            border: '1px solid',
            borderColor: theme.palette.grey[200],
            flexDirection: 'column',
            overflow: 'hidden',
            flexGrow: 1,
          })}
        >
          <ExamLocationRequestListNavigationTabs />
          <Divider
            sx={{
              mt: '-1px',
            }}
          />
          <ExamLocationRequestList />
        </Flex>
      </Flex>
    </PaperSection>
  );
}
